export const MAX_DATA_FILE_SIZE = 500 * 1024 * 1024; // 500MB
export const MAX_DATA_FILE_SIZE_LABEL = '500MB';
// Cloud Run rejects HTTP request bodies above ~32MB; use direct GCS upload above this threshold
export const DIRECT_UPLOAD_MAX_SIZE = 25 * 1024 * 1024; // 25MB
